module.exports = __webpack_public_path__ + "static/1-formation-deformation-s-a2-6b4c17f660e9023e2e05a1b97ceb98f3.jpg";